import { map } from 'rxjs/operators';
import http from '../../helpers/APIHelper';

export const CIRB_QUEUED_ACTIONS = {
  CURRENT_QUEUED_ITEMS: '@regulatory/cirb/currentQueuedItems'
};

const jobsToProcessAction = (payload) => ({
  type: CIRB_QUEUED_ACTIONS.CURRENT_QUEUED_ITEMS,
  payload
});

// GET API // => fetched from DB if there is any job ---> CIRB GRID -On Process -> protocol
export const checkQueuedProcessJobs = (token, loggerInfo, username) => (dispatch) => http
  .getWithToken(
    `regulatory-data-service/${process.env.REACT_APP_PERSON_API_VERSION}/cap/user/${username}/queuedprocess`,
    token,
    loggerInfo,
    {},
    'json',
    true
  )
  .pipe(
    map((resp) => {
      dispatch(jobsToProcessAction(resp.response || []));
      return resp.response;
    })
  );

export const getQueuedEvnetsAction = (token, loggerInfo) => () => http.getWithToken(
  `regulatory-data-service/${process.env.REACT_APP_PERSON_API_VERSION}/cap/queuedprocess`,
  token,
  loggerInfo
);
